import { render, staticRenderFns } from "./thirdGuide.vue?vue&type=template&id=767f6e54&scoped=true"
import script from "./thirdGuide.vue?vue&type=script&lang=js"
export * from "./thirdGuide.vue?vue&type=script&lang=js"
import style0 from "./thirdGuide.vue?vue&type=style&index=0&id=767f6e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f6e54",
  null
  
)

export default component.exports